import { Container } from '@cleartrip/ct-design-components'
import { useEffect, useState } from 'react'
import styles from './cfwBanner.module.scss'

type BorderAnimationProps = {
    className?: string
    children?: React.ReactNode
    startAnimation?: boolean
}
const BorderAnimation = ({ className, children, startAnimation = false }: BorderAnimationProps) => {
    const [animationCompleted, setAnimationCompleted] = useState(false)
    const defaultBorderClass = styles.ba
    const animationBorderClass = animationCompleted ? defaultBorderClass : styles['border-animation']

    useEffect(() => {
        setTimeout(() => {
            setAnimationCompleted(true)
        }, 4000)
    }, [])
    return startAnimation ? (
        <Container className={`o-hidden ${className} ${animationBorderClass}`}>
            {!animationCompleted
                ? [...Array(4)].map((_, i) => (
                      <Container
                          key={i}
                          className={styles[`border-animation-${i + 1}`]}
                      />
                  ))
                : null}
            <Container position="relative" zIndex={2} style={{ borderRadius: 5, background: '#fff' }}>
                {children}
            </Container>
        </Container>
    ) : (<>{children}</>)
}

export default BorderAnimation
